// SYNCED FROM: VidaReactNative/src/constants/lob.ts — keep in sync. See SYNC.md.
/**
 * Lob publishable key — used for client-side US address verification.
 *
 * We use the live key in every environment because Lob's test key does not
 * actually verify addresses — it only validates request shape and returns
 * canned responses keyed off special `primary_line` values.
 *
 * See: https://help.lob.com/account-management/api-keys
 */
export const LOB_PUBLISHABLE_KEY = process.env.EXPO_PUBLIC_LOB_PUBLISHABLE_KEY ?? '';

export const LOB_API_BASE_URL = 'https://api.lob.com/v1';
